import { type FC, type ReactNode, type ChangeEvent } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { Input } from 'dibs-elements/exports/Input.tsx';

type Props = {
    errorMessage?: ReactNode;
    value: string;
    isLoading?: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const messages = defineMessages({
    firstName: {
        id: 'DealerApplicationForm.firstName.placeHolder',
        defaultMessage: 'First Name',
    },
});

const FirstName: FC<Props> = ({ errorMessage, value, isLoading, onChange }) => {
    const intl = useIntl();
    return (
        <Input
            dataTn="first-name-contact"
            name="first-name-contact"
            placeholder={intl.formatMessage(messages.firstName)}
            hasAnimatedPlaceholder
            autoComplete="given-name"
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={isLoading}
            value={value}
        />
    );
};

export default FirstName;
